import { Box, Icon, IconButton } from '@mui/material'
import React from 'react'

import Logo from '@/app/component/atom/logo'
import { Balance, Organization, SelectOption } from '@/app/types'

import { Content, HelpMenuContainer, Right, StyledLink } from './common'
import HelpMenu from './help-menu'
import MobileDrawer from './mobile-drawer'
import NonAuthNav from './non-auth-nav'

type Props = {
  activeOrg?: Organization
  balance?: Balance
  currentPage: string
  email: string
  organizations?: SelectOption<number>[]
  isAuthorized: boolean
  hasOrg: boolean
  mobileMenuOpen: boolean
  onToggleMobileNav: () => void
  logout?: () => void
  onOrgSelect: (org: SelectOption<number>) => void
}

const MobileHeader: React.FC<Props> = ({
  activeOrg,
  balance,
  currentPage,
  email,
  organizations = [],
  isAuthorized,
  hasOrg,
  mobileMenuOpen,
  onToggleMobileNav,
  logout = () => {},
  onOrgSelect,
}) => (
  <>
    {isAuthorized && (
      <Box sx={{ mr: 1 }}>
        <IconButton data-testid="nav-mobile-toggle" color="inherit" onClick={onToggleMobileNav}>
          <Icon>dehaze</Icon>
        </IconButton>
      </Box>
    )}
    <StyledLink to="/">
      <Logo />
    </StyledLink>
    <Content>
      {hasOrg && (
        <MobileDrawer
          open={mobileMenuOpen}
          onClose={onToggleMobileNav}
          hasOrg={hasOrg}
          activeOrg={activeOrg}
          balance={balance}
          organizations={organizations}
          email={email}
          currentPage={currentPage}
          logout={logout}
          onOrgSelect={onOrgSelect}
        />
      )}
      <Right>
        <HelpMenuContainer>
          <HelpMenu classes={{ dropdownLink: '' }} />
        </HelpMenuContainer>
        {!isAuthorized && <NonAuthNav currentPage={currentPage} />}
      </Right>
    </Content>
  </>
)

export default MobileHeader
